import * as React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow, map } from 'lodash';
import { connect } from 'react-redux';
import { isEmail, isRequired } from '../../../../../../util/validators';
import { IStore } from '../../../../../../redux/IStore';
import PasswordInput from '../../../../../../components/PasswordInput';
import { Link } from 'react-router-dom';

interface IResetPasswordFormProps {
  actions: {
    push: (route: string) => void;
  };
  buttonText: string;
}

class ResetPasswordForm extends React.Component<IResetPasswordFormProps> {
  public render() {
    const { handleSubmit, buttonText, auth, submitting } = this.props;
    const hasAuthErrors = auth && auth.error && ((auth.error.login && auth.error.login.length) ||
      (auth.error.reset && auth.error.reset.length) || (auth.error.update && auth.error.update.length));
    const validationMessages = ['Error: Password must be at least 12 characters long', 'Error: Password must include at least one special character such as !@#$%?']

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div>
          <div>
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Registered email
              </Col>
              <Col sm={9}>
                <Field
                  name="email"
                  type="email"
                  autocomplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired, isEmail]}
                />
              </Col>
            </FormGroup>
          </div>
          <div>
            <div className="margin-bottom">
              Your password must be a minimum of 10 characters long with at least one lower case, one
              uppercase letter,
              one number and one of the following special characters : !@#$%?
            </div>
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={3}>
                New Password
              </Col>
              <Col sm={9}>
                <Field
                  name="password"
                  type="password"
                  autocomplete="new-password"
                  component={PasswordInput}
                  strengthMeter={true}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={3}>
                Confirm new password
              </Col>
              <Col sm={9}>
                <Field
                  name="passwordConfirmation"
                  type="password"
                  autocomplete="new-password"
                  component={PasswordInput}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        {!!hasAuthErrors && (
          <div className="alert alert-danger" style={{ marginTop: '10px' }}>
            {map(auth.error.reset, (error, key) => {
              if (error.detail === 'Cannot use insecure password') {
                return <p>Unfortunately the password you have chosen contains a word that is in our banned list of
                  passwords. Please choose a password that is more secure.</p>;
              } else if (validationMessages.includes(error.detail)) {
                return <p key={key}>{error.detail.replace('12', '10')}</p>
              } else {
                return <p key={key}>{error.detail} You can do so by clicking <Link
                  to="/auth/remind">here
                </Link>.
                </p>;
              }
            })}
          </div>
        )}
        <div className="btn-bar mt-30">
          <Button
            bsStyle="primary"
            type="submit"
            className="pull-right secondary-button"
            disabled={submitting}
          >
            {buttonText ? buttonText : 'SAVE CHANGES'}
          </Button>
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Your confirmed password doesn\'t ' +
      'match the first field, please enter them again.';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    validate,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('reset_password');

    return component;
  },
  connect(
    (state: IStore) => ({
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ResetPasswordForm);
